// extracted by mini-css-extract-plugin
export default {"wrapper":"ThankYou_wrapper__IjeFl","title":"ThankYou_title__bpdKb","text":"ThankYou_text__e59JS"};